import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { Button } from 'react-bootstrap/lib';
import withRolePermission from './RolePermission';

function EditButton({ role, onEdit }) {
  return (
    <div>
      <Button
        title="Edit"
        key={role.role}
        id={`split-button-basic-${role.role}`}
        onClick={() => {
          onEdit(role.role);
        }}
      >
        Edit
      </Button>
    </div>
  );
}

EditButton.propTypes = {
  role: PropTypes.object,
  onEdit: PropTypes.func,
};

export default withRolePermission(Permissions.UPDATE)(EditButton);
